import {
  GetNotifications,
  GetNotificationsVariables,
} from "_graphql/queries/__generated__/GetNotifications";

import { getNotifications } from "_graphql/visal/queries/notifications";
import { useQuery } from "@apollo/client";

export const useNotifications = (variables?: GetNotificationsVariables) => {
  const { data, ...rest } = useQuery<
    GetNotifications,
    GetNotificationsVariables
  >(getNotifications, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });
  return {
    notifications: data?.getNotifications || [],
    length: data?.getNotificationsCount || 0,
    ...rest,
  };
};
